export default __webpack_public_path__ + "static/200-fbae325ca54e6fc2766396c36460106f.jpg";